import { render } from "./Cita.vue?vue&type=template&id=57ec3bf6&scoped=true&ts=true"
import script from "./Cita.vue?vue&type=script&lang=ts"
export * from "./Cita.vue?vue&type=script&lang=ts"

import "./Cita.vue?vue&type=style&index=0&id=57ec3bf6&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ec3bf6"]])

export default __exports__